import InputAdornment from "@mui/material/InputAdornment";

export default InputAdornment;
